import {
  IconButton,
  Speaker,
  SpeakerMute,
} from '@amzn/ring-ui-react-components';
import { MouseEventHandler } from 'react';

interface VolumeProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  isMuted?: boolean;
  'data-testid'?: string;
}

export const Volume = (props: VolumeProps) => (
  <>
    <IconButton
      data-testid={props['data-testid']}
      aria-label="Toggle Volume"
      onClick={props.onClick}
      variant="unstyled"
      color="white"
      size="xs"
      mr={3}
      position="relative"
    >
      {props.isMuted ? (
        <SpeakerMute boxSize="24px" />
      ) : (
        <Speaker boxSize="24px" />
      )}
    </IconButton>
  </>
);
